import React from "react";
import DatePicker from "../../common/DatePicker";
import RxNumber from "../../common/RxNumber";
import PhoneNumber from "../../common/input/PhoneNumber";
import GenericInput from "../../common/input/GenericInput";
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";

export default class NonBSWPharamacyInfo extends React.Component {

    constructor(props) {
        super(props);
        //this.completed = props.completed;
        this.state = { showAsInvalid: false, checked: false, RXTransferData: props.transferData };
    }

    componentWillMount() {
        var RXTransferData = this.state.RXTransferData;
        if (RXTransferData.PrescriptionInfo.length === 0) {
            RXTransferData.PrescriptionInfo.push({ RxDrugName: '', RxNumber: '', id: RXTransferData.PrescriptionInfo.length });
            this.setState({ RXTransferData });
        }
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Rx.NonBSWPharamacyInfo.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    countOfValidPrescriptions(prescriptions) {
        let count = 0;
        if (prescriptions.length > 0) {
            for (let i = 0; i < prescriptions.length; i++) {
                if (prescriptions[i].RxDrugName && prescriptions[i].RxNumber) {
                    count++;
                }
            }
        }
        return count;
    }

    isValid() {
        const rxInfo = this.state.RXTransferData;        
        const prescriptions = rxInfo.PrescriptionInfo;

        const isValid = rxInfo["patientPhoneValid"] && rxInfo.DateOfBirth && rxInfo.ExternalPharmacyDetail &&
            rxInfo.ExternalPharmacyDetail.Name && rxInfo["pharmacyPhoneValid"] &&
            prescriptions.length === this.countOfValidPrescriptions(prescriptions) &&
            (!rxInfo.isInsurance || (rxInfo.InsuranceDetail && rxInfo.InsuranceDetail.InsuranceName !== "" &&
                rxInfo.InsuranceDetail.MemberNumber !== "" && rxInfo.InsuranceDetail.RxBIN !== "" &&
                rxInfo.InsuranceDetail.RxPCNNumber !== "" && rxInfo.InsuranceDetail.InsuranceGroupIdb !== ""));

        return /*this.completed || */isValid;
    }

    onGoNext(success) {
        if (!success) {
            this.setState({ showAsInvalid: true });
            //if (typeof window !== 'undefined') {
            //    window.scrollTo(0, 0);
            //}
        }
        if (this.props.onGoNext) {
            this.props.onGoNext(success);
        }        
    }

    handleInputChange(group, event, isValid) {
        const RXTransferData = this.state.RXTransferData;
        if (event) {
            const target = event.target;
            const value = !target ? event : target.type === 'checkbox' ? target.checked : target.value;
            if (group === 'Generic') {
                if (!target) {
                    var utcDate = value;
                    var formattedDOBDate = '';
                    if (utcDate && isValid) {
                        formattedDOBDate = this.formatDate(utcDate);
                    }
                    RXTransferData["DateOfBirth"] = formattedDOBDate;
                } else {
                    RXTransferData[target.name] = value;
                    if (target.name === "PhoneNumber")
                        RXTransferData["patientPhoneValid"] = isValid;
                }
            } else if (group === 'InsuranceDetail') {
                RXTransferData.InsuranceDetail[target.name] = value;
            } else if (group === 'ExternalPharmacyDetail') {
                RXTransferData.ExternalPharmacyDetail[target.name] = value;
                if (target.name === "PhoneNumber")
                    RXTransferData["pharmacyPhoneValid"] = isValid;
            }
        }
        else {
            RXTransferData["DateOfBirth"] = "";
        }

        this.setState({ RXTransferData}, () => this.touched());
    }

    formatDate(d) {
        var date = new Date(d);
        var dd = date.getDate();
        var mm = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10) { dd = '0' + dd; }
        if (mm < 10) { mm = '0' + mm; }
        return d = mm + '/' + dd + '/' + yyyy;
    }

    toggleInsurance() {
        this.setState({ checked: this.state.checked ? false : true });
    }

    addPrescription() {
        var RXTransferData = this.state.RXTransferData;
        var rxList = RXTransferData.PrescriptionInfo;
        if (rxList[rxList.length - 1].RxNumber && rxList[rxList.length - 1].RxDrugName) {
            RXTransferData.PrescriptionInfo.push({ RxDrugName: '', RxNumber: '', id: rxList[rxList.length - 1].id + 1 });
            this.setState({ RXTransferData });
            logUI("MBHWeb.Rx.Transfer.External.AddPrescription", new Date(), Tools.getURLPath());
        }
    }

    removePrescription = (item) => {
        const { onChange } = this.props;
        const { RXTransferData } = this.state;

        const index = RXTransferData.PrescriptionInfo.findIndex(i => i.id === item.id);

        if (index !== -1 && RXTransferData.PrescriptionInfo.length > 1) {
            RXTransferData.PrescriptionInfo.splice(index, 1);
            const isValid = this.state.isValid && RXTransferData.PrescriptionInfo.length === this.countOfValidPrescriptions(RXTransferData.PrescriptionInfo);
            this.setState({ RXTransferData: { ...RXTransferData, isValid } }, () => {               
                if (onChange) {
                    onChange(this.state.RXTransferData);
                }
            });
            logUI("MBHWeb.Rx.Transfer.External.RemovePrescription", new Date(), Tools.getURLPath(), JSON.stringify({ Rx: item }));
        }
    };

    onRxNameChange = (index, e) => {
        var RXTransferData = this.state.RXTransferData;
        if (RXTransferData.PrescriptionInfo[index]) {
            RXTransferData.PrescriptionInfo[index].RxDrugName = e.target.value;
        }
        this.setState({ RXTransferData }, () => this.touched());
    }

    onRxNumberChange = (index, e, isRxNumberValid) => {
        var RXTransferData = this.state.RXTransferData;
        if (RXTransferData.PrescriptionInfo[index]) {
            RXTransferData.PrescriptionInfo[index].RxNumber = isRxNumberValid && e.target.value;
        }
        this.setState({ RXTransferData }, () => this.touched());
    }

    touched() {
        const { onChange } = this.props;
        const { PhoneNumber, DateOfBirth, isInsurance, ExternalPharmacyDetail, PrescriptionInfo } = this.state.RXTransferData;
        const isValid = this.isValid();
        const touched = isValid || PhoneNumber !== '' || DateOfBirth !== '' || isInsurance || ExternalPharmacyDetail.Address !== '' ||
            ExternalPharmacyDetail.Name !== '' || ExternalPharmacyDetail.PhoneNumber !== '' ||
            PrescriptionInfo[0].RxNumber !== '' || PrescriptionInfo[0].RxDrugName !== '';

        this.setState({ RXTransferData: { ...this.state.RXTransferData, touched, isValid } }, () => {            
            if (onChange) {
                onChange(this.state.RXTransferData);
            }
        });
    }

    render() {
        const rxInfo = this.state.RXTransferData;
        const { showAsInvalid } = this.state;
        const rxListInfo = rxInfo.PrescriptionInfo;
        const enableNewEntry = rxListInfo ? !(rxListInfo[rxListInfo.length - 1].RxNumber && rxListInfo[rxListInfo.length - 1].RxDrugName) : false;

        return (
            <div style={this.props.style} className="pharmacy-info-container">
                <div className="row">
                    <div className="col-12">
                        <h2 className="form-section-heading">Patient Information</h2>
                    </div>
                    <div className="col-12 col-sm-6 col-md-6 form-group">
                        <PhoneNumber name="PhoneNumber" placeholder="Phone Number"
                            onChange={(e, isValid) => this.handleInputChange('Generic', e, isValid)} value={rxInfo.PhoneNumber} ref="PhoneNumber" required
                            tooltipID="rxPhoneNumber" tooltipMsg="The phone number must match what your pharmacy has on file."
                            showAsInvalid={showAsInvalid && (!rxInfo.PhoneNumber || rxInfo.PhoneNumber.length !== 12)}
                        />
                    </div>
                    <div className="col-12 col-sm-6 col-md-6 form-group">
                        <DatePicker yearsBackward={140} maxDate={new Date()} name="DateOfBirth"
                            required value={rxInfo.DateOfBirth} ref="dob"
                            onChange={(e, isValid) => this.handleInputChange('Generic', e, isValid)}
                            showAsInvalid={showAsInvalid && !rxInfo.DateOfBirth}
                        />
                    </div>
                    <div className="col-12">
                        <label className="checkbox-container">
                            <input type="checkbox" checked={rxInfo.isInsurance} name="isInsurance" onChange={(e) => this.handleInputChange('Generic', e)} />
                            <span className="checkmark" />
                            <span className="checkbox-label">I have insurance.</span>
                        </label>
                    </div>
                </div>

                {rxInfo.isInsurance &&
                    <div className="row">
                        <div className="col-12">
                            <h2 className="form-section-heading">Insurance Information</h2>
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 form-group">
                            <GenericInput name="InsuranceName" placeholder="Company Name" required
                                value={rxInfo.InsuranceDetail.InsuranceName} ref="InsuranceCompanyName"
                                onChange={e => this.handleInputChange('InsuranceDetail', e)}
                                showAsInvalid={showAsInvalid && rxInfo.isInsurance && (!rxInfo.InsuranceDetail || !rxInfo.InsuranceDetail.InsuranceName)}
                            />
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 form-group">
                            <GenericInput name="InsuranceGroupId" placeholder="RX Group Number" required
                                value={rxInfo.InsuranceDetail.InsuranceGroupId} ref="RXGroupNumber"
                                onChange={(e) => this.handleInputChange('InsuranceDetail', e)}
                                showAsInvalid={showAsInvalid && rxInfo.isInsurance && (!rxInfo.InsuranceDetail || !rxInfo.InsuranceDetail.InsuranceGroupId)}
                            />
                        </div>
                        <div className="col-12 col-sm-4 col-md-4 form-group">
                            <GenericInput name="MemberNumber" placeholder="RX Member Number" required
                                value={rxInfo.InsuranceDetail.MemberNumber} ref="RXMembernumber"
                                onChange={(e) => this.handleInputChange('InsuranceDetail', e)}
                                showAsInvalid={showAsInvalid && rxInfo.isInsurance && (!rxInfo.InsuranceDetail || !rxInfo.InsuranceDetail.MemberNumber)}
                            />
                        </div>
                        <div className="col-12 col-sm-4 col-md-4 form-group">
                            <GenericInput name="RxBIN" placeholder="RX BIN Number" required
                                value={rxInfo.InsuranceDetail.RxBIN} ref="RXBINNumber"
                                onChange={(e) => this.handleInputChange('InsuranceDetail', e)}
                                showAsInvalid={showAsInvalid && rxInfo.isInsurance && (!rxInfo.InsuranceDetail || !rxInfo.InsuranceDetail.RxBIN)}
                            />
                        </div>
                        <div className="col-12 col-sm-4 col-md-4 form-group">
                            <GenericInput name="RxPCNNumber" placeholder="RX PCN Number"
                                value={rxInfo.InsuranceDetail.RxPCNNumber} required ref="RXPCNNumber"
                                onChange={(e) => this.handleInputChange('InsuranceDetail', e)}
                                showAsInvalid={showAsInvalid && rxInfo.isInsurance && (!rxInfo.InsuranceDetail || !rxInfo.InsuranceDetail.RxPCNNumber)}
                            />
                        </div>
                    </div>
                }

                <div className="row">
                    <div className="col-12">
                        <h2 className="form-section-heading">Pharmacy Information</h2>
                    </div>
                    <div className="col-12 col-sm-6 col-md-6 form-group">
                        <GenericInput name="Name" placeholder="Name" required
                            value={rxInfo.ExternalPharmacyDetail.Name} ref="ExternalpharmacyName"
                            onChange={(e) => this.handleInputChange('ExternalPharmacyDetail', e)}
                            showAsInvalid={showAsInvalid && !rxInfo.ExternalPharmacyDetail.Name}
                        />
                    </div>
                    <div className="col-12 col-sm-6 col-md-6 form-group">
                        <PhoneNumber name="PhoneNumber" placeholder="Phone Number" required
                            value={rxInfo.ExternalPharmacyDetail.PhoneNumber} ref="ExternalpharmacyPhoneNumber"
                            onChange={(e, isValid) => this.handleInputChange('ExternalPharmacyDetail', e, isValid)}
                            showAsInvalid={showAsInvalid && (!rxInfo.ExternalPharmacyDetail.PhoneNumber || rxInfo.ExternalPharmacyDetail.PhoneNumber.length !== 12)}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <h2 className="form-section-heading">Prescription Information</h2>
                        {rxListInfo.map((item, index) => (
                            <div className="row" key={item.id}>
                                <div className="col-xs-12 col-sm-6 col-md-6 form-group">
                                    <GenericInput name={"PRName" + item.id} placeholder="Name" required
                                        value={rxListInfo[index].RxDrugName} ref={"PRName" + item.id}
                                        onChange={(e) => this.onRxNameChange(index, e)}
                                        showAsInvalid={showAsInvalid && !rxListInfo[index].RxDrugName}
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 form-group input-group">
                                    <RxNumber name={"PRRXNumber" + item.id} rxNumberId={"PRRXNumber" + item.id} placeholder="RX Number"
                                        required value={rxListInfo[index].RxNumber} ref={"PRRXNumber" + item.id}
                                        onChange={(e, isRxNumberValid) => this.onRxNumberChange(index, e, isRxNumberValid)}
                                        showAsInvalid={showAsInvalid && !rxListInfo[index].RxNumber}
                                    />
                                    {rxInfo.PrescriptionInfo.length > 1 &&
                                        <div className="input-group-append delete-rx-btn">
                                            <a className="icon-close" onClick={() => this.removePrescription(item)} readOnly />
                                        </div>
                                    }
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="row">
                    <div className={"col-12 new-entry-btn form-group" + (enableNewEntry ? " disabled-style" : "")}>
                        <a onClick={() => this.addPrescription()}><span className="icon-circle-plus" />Add another prescription</a>
                    </div>
                </div>
            </div>
        );
    }
}